export const GOOGLE_MAPS_QUERY_TEMPLATE = 'https://www.google.com/maps?q='

export const SOCIAL_LINKS = {
  FACEBOOK: 'https://www.facebook.com/startupcraft.io',
  TWITTER: 'https://twitter.com/startupcraftio',
  MEDIUM: 'https://medium.com/startupcraft',
  LINKED_IN: 'https://www.linkedin.com/company/startupcraft',
  UPWORK: 'https://www.upwork.com/o/companies/~017a75f81b71aeddc3/',
  CLUTCH: 'https://clutch.co/profile/startupcraft',
  GITHUB: 'https://github.com/StartupCraft',
  CRUNCHBASE: 'https://www.crunchbase.com/organization/startupcraft',
}

export const CLUTCH_REVIEW_DATA = {
  dataUrl: 'https://widget.clutch.co',
  scriptSrc: 'https://widget.clutch.co/static/js/widget.js',
  companyId: '139131',
  link: 'https://clutch.co/profile/startupcraft?utm_source=widget&utm_medium=2&utm_campaign=widget&utm_content=num_reviews&utm_term=localhost#reviews',
}

export const DATO_CMS_ENDPOINTS = {
  preview: `https://graphql.datocms.com/preview`,
  production: `https://graphql.datocms.com/`,
}
